export function SortAscending({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <g transform="translate(0.97 2.59)">
          <path
            d="M13.95 1.89327V14.0766M0.75 2.07638H7.75M0.75 6.64258H7.75M0.75 11.2097H4.13333M17 4.1016L13.95 1.05994L10.9083 4.1016"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="square"
          />
        </g>
      </svg>
    </span>
  );
}
